module.exports = __webpack_public_path__ + "img/pl.14be9e42.svg";